import $ from 'cash-dom';
import prestashop from 'prestashop';
import {psGetRequestParameter} from './common';

// Used to be able to abort request if user modify something
let currentRequest = null;

// Used to clearTimeout if user flood the product quantity input
let currentRequestDelayedId = null;

// Check for popState event
let isOnPopStateEvent = false;

// Register form of first update
const firstFormData = [];

// Detect if the form has changed one time
let formChanged = false;

/**
 * Get product update URL from different
 * sources if needed (for compatibility)
 *
 * @return {Promise}
 */
function getProductUpdateUrl() {
  const $productActions = $(prestashop.selectors.product.actions);
  const $quantityWantedInput = $(prestashop.selectors.quantityWanted);

  // Fast path (same as before)
  if (
    prestashop &&
    prestashop.urls &&
    prestashop.urls.pages &&
    prestashop.urls.pages.product
  ) {
    return Promise.resolve(prestashop.urls.pages.product);
  }

  const form = $productActions.find('form:first')[0];
  const formData = new FormData(form);

  // Convert FormData to plain object
  const data = Object.fromEntries(formData.entries());

  // Add extra fields
  data.ajax = 1;
  data.action = 'productrefresh';
  data.quantity_wanted = $quantityWantedInput.val();

  return fetch(form.action, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams(data).toString(),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json();
    })
    .then((data) => {
      return data.productUrl;
    })
    .catch((error) => {
      // match old reject structure if needed
      return Promise.reject({
        error,
      });
    });
}
/**
 * @param {string} errorMessage
 */
function showErrorNextToAddtoCartButton(errorMessage) {
  showError(
    /* eslint-disable */
    $(
      ".quickview #product-availability, .page-product:not(.modal-open) .row #product-availability, .page-product:not(.modal-open) .product-container #product-availability"
    ),
    /* eslint-enable */
    errorMessage,
  );
}

/**
 * Update the product html
 *
 * @param {string} event
 * @param {string} eventType
 * @param {string} updateUrl
 */
let currentRequestController = null;

function updateProduct(event, eventType, updateUrl) {
  const $productActions = $(prestashop.selectors.product.actions);
  const $quantityWantedInput = $productActions.find(
    prestashop.selectors.quantityWanted
  );

  const $form = $productActions.find('form').first();
  const formEl = $form[0];

  const formData = new FormData(formEl);
  const formSerialized = new URLSearchParams(formData).toString();

  let preview = psGetRequestParameter('preview');
  preview = preview !== null ? `&preview=${preview}` : '';

  if (updateUrl === null) {
    showErrorNextToAddtoCartButton();
    return;
  }

  if (
    event &&
    event.type === 'keyup' &&
    $quantityWantedInput.val() === $quantityWantedInput.data('old-value')
  ) {
    return;
  }

  $quantityWantedInput.data('old-value', $quantityWantedInput.val());

  if (currentRequestDelayedId) {
    clearTimeout(currentRequestDelayedId);
  }

  let updateDelay = eventType === 'updatedProductQuantity' ? 750 : 30;

  currentRequestDelayedId = setTimeout(() => {
    if (!formSerialized) return;

    // Abort previous request
    if (currentRequestController) {
      currentRequestController.abort();
    }

    currentRequestController = new AbortController();

    const url =
      updateUrl +
      (updateUrl.indexOf('?') === -1 ? '?' : '&') +
      formSerialized +
      preview;

    const payload = new URLSearchParams({
      quickview: $('.modal.quickview.in').length,
      ajax: 1,
      action: 'refresh',
      quantity_wanted:
        eventType === 'updatedProductCombination'
          ? $quantityWantedInput.attr('min')
          : $quantityWantedInput.val(),
    });

    fetch(url, {
      method: 'POST',
      body: payload,
      signal: currentRequestController.signal,
    })
      .then((res) => {
        if (!res.ok) throw new Error('Request failed');
        return res.json();
      })
      .then((data) => {
        const $newImagesContainer = $('<div>').append(
          data.product_cover_thumbnails
        );

        if (
          $(prestashop.selectors.product.imageContainer).html() !==
          $newImagesContainer
            .find(prestashop.selectors.product.imageContainer)
            .html()
        ) {
          $(prestashop.selectors.product.imageContainer).replaceWith(
            data.product_cover_thumbnails
          );
        }

        $(prestashop.selectors.product.prices).first().replaceWith(data.product_prices);
        $(prestashop.selectors.product.customization).first().replaceWith(data.product_customization);
        $(prestashop.selectors.product.inputCustomization).val(0);
        $(prestashop.selectors.product.variantsUpdate).first().replaceWith(data.product_variants);
        $(prestashop.selectors.product.discounts).first().replaceWith(data.product_discounts);
        $(prestashop.selectors.product.additionalInfos).first().replaceWith(data.product_additional_info);
        $(prestashop.selectors.product.details).replaceWith(data.product_details);
        $(prestashop.selectors.product.flags).first().replaceWith(data.product_flags);

        replaceAddToCartSections(data);

        const minimalProductQuantity = parseInt(
          data.product_minimal_quantity,
          10
        );

        if (
          !isNaN(minimalProductQuantity) &&
          eventType !== 'updatedProductQuantity'
        ) {
          $quantityWantedInput.attr('min', minimalProductQuantity);
          $quantityWantedInput.val(minimalProductQuantity);
        }

        // ✅ serializeArray replacement
        const formArray = Array.from(formData.entries()).map(
          ([name, value]) => ({ name, value })
        );

        prestashop.emit('updatedProduct', data, formArray);
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;

        if ($('section#main > .ajax-error').length === 0) {
          showErrorNextToAddtoCartButton();
        }
      })
      .finally(() => {
        currentRequestController = null;
        currentRequestDelayedId = null;
      });
  }, updateDelay);
}

/**
 * Replace all "add to cart" sections but the quantity input
 * in order to keep quantity field intact i.e.
 *
 * @param {object} data of updated product and cat
 */
function replaceAddToCartSections(data) {
  let $productAddToCart = null;

  $(data.product_add_to_cart).each((index, value) => {
    if ($(value).hasClass('product-add-to-cart')) {
      $productAddToCart = $(value);

      return false;
    }

    return true;
  });

  if ($productAddToCart === null) {
    showErrorNextToAddtoCartButton();
  }
  const $addProductToCart = $(prestashop.selectors.product.addToCart);
  const productAvailabilitySelector = '.add';
  const productAvailabilityMessageSelector = '#product-availability';
  const productMinimalQuantitySelector = '.product-minimal-quantity';

  replaceAddToCartSection({
    $addToCartSnippet: $productAddToCart,
    $targetParent: $addProductToCart,
    targetSelector: productAvailabilitySelector,
  });

  replaceAddToCartSection({
    $addToCartSnippet: $productAddToCart,
    $targetParent: $addProductToCart,
    targetSelector: productAvailabilityMessageSelector,
  });

  replaceAddToCartSection({
    $addToCartSnippet: $productAddToCart,
    $targetParent: $addProductToCart,
    targetSelector: productMinimalQuantitySelector,
  });
}

/**
 * Find DOM elements and replace their content
 *
 * @param {object} replacement Data to be replaced on the current page
 */
function replaceAddToCartSection(replacement) {
  const destinationObject = $(
    replacement.$targetParent.find(replacement.targetSelector),
  );

  if (destinationObject.length <= 0) {
    return;
  }
  const replace = replacement.$addToCartSnippet.find(
    replacement.targetSelector,
  );

  if (replace.length > 0) {
    destinationObject.replaceWith(replace[0].outerHTML);
  } else {
    destinationObject.html('');
  }
}

/**
 * @param {jQuery} $container
 * @param {string} textError
 */
function showError($container, textError) {
  const $error = $(
    `<div class="alert alert-danger ajax-error" role="alert">${textError}</div>`,
  );
  $container.replaceWith($error);
}

$(document).ready(() => {
  const $productActions = $(prestashop.selectors.product.actions);

  // Listen on all form elements + those who have a data-product-attribute
  $('body').on(
    'change touchspin.on.startspin',
    `${prestashop.selectors.product.variants} *[name]`,
    (e) => {
      formChanged = true;

      prestashop.emit('updateProduct', {
        eventType: 'updatedProductCombination',
        event: e,
        // Following variables are not used anymore, but kept for backward compatibility
        resp: {},
        reason: {
          productUrl: prestashop.urls.pages.product || '',
        },
      });
    },
  );

  // Stocking first form information
  $($productActions.find('form').first().serializeArray()).each(
    (k, {value, name}) => {
      firstFormData.push({value, name});
    },
  );

  window.addEventListener('popstate', (event) => {
    isOnPopStateEvent = true;

    if (
      (!event.state
        || (event.state && event.state.form && event.state.form.length === 0))
      && !formChanged
    ) {
      return;
    }

    const $form = $(prestashop.selectors.product.actions).find('form').first();

    if (event.state && event.state.form) {
      event.state.form.forEach((pair) => {
        $form.find(`[name="${pair.name}"]`).val(pair.value);
      });
    } else {
      firstFormData.forEach((pair) => {
        $form.find(`[name="${pair.name}"]`).val(pair.value);
      });
    }

    prestashop.emit('updateProduct', {
      eventType: 'updatedProductCombination',
      event,
      // Following variables are not used anymore, but kept for backward compatibility
      resp: {},
      reason: {
        productUrl: prestashop.urls.pages.product || '',
      },
    });
  });

  /**
   * Button has been removed on classic theme, but event triggering has been kept for compatibility
   */
  $('body').on(
    'click',
    prestashop.selectors.product.refresh,
    (e, extraParameters) => {
      e.preventDefault();
      let eventType = 'updatedProductCombination';

      if (typeof extraParameters !== 'undefined' && extraParameters.eventType) {
        // eslint-disable-next-line
        eventType = extraParameters.eventType;
      }

      prestashop.emit('updateProduct', {
        eventType,
        event: e,
        // Following variables are not used anymore, but kept for backward compatibility
        resp: {},
        reason: {
          productUrl: prestashop.urls.pages.product || '',
        },
      });
    },
  );

  // Refresh all the product content
  prestashop.on('updateProduct', (args) => {
    const {eventType} = args;
    const {event} = args;

    getProductUpdateUrl()
      .then((productUpdateUrl) => updateProduct(event, eventType, productUpdateUrl),
      )
      /*.catch((error) => {
        if ($('section#main > .ajax-error').length === 0) {
        //   showErrorNextToAddtoCartButton();
        }
      });*/
  });


  prestashop.on('updateCart', (event) => {
    if (!event || !event.reason || event.reason.linkAction !== 'add-to-cart') {
      return;
    }
    const $quantityWantedInput = $('#quantity_wanted');
    // Force value to 1, it will automatically trigger updateProduct and reset the appropriate min value if needed
    $quantityWantedInput.val(1);
  });

  prestashop.on('showErrorNextToAddtoCartButton', (event) => {
    if (!event || !event.errorMessage) {
      return;
    }

    showErrorNextToAddtoCartButton(event.errorMessage);
  });
});
